import React from 'react';
import TruckDesc from '../screens/truck_desc';

function Camiones() {
    return (
      <div className="px-6 py-10 max-w-7xl mx-auto">
       
 

        <TruckDesc/>




  
      </div>
    );
  }
  
  export default Camiones;